import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../config/react'
import DataTable from 'react-data-table-component'

const Subscribers = () => {
  const [SubscribersList, setSubscribersList] = useState([])

  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [SearchTerm, setSearchTerm] = useState('')
  const columns = [
    {
      name: 'Email',
      sortable: true,
      sortField: 'email',
      selector: (row) => row.email
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          {row.status === 1 ? (
            <Link
              onClick={(e) => DeleteSubscriber(e, row.id)}
              to="#"
              className="text-dark"
              title="Inactive"
            >
              <i
                className="fa fa-ban"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          ) : (
            ''
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Subscriber
    GetSubscribersList()
  }, [CustomFilters, SearchTerm])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Email."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  const GetSubscribersList = () => {
    const newsletterEmailData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // HttpService.getApi(API.GetSubscribersList).then(response => {
    setLoading(true)
    HttpService.postApi(API.GetSubscribersList, newsletterEmailData).then((response) => {
      setLoading(false)
      // setSubscribersList(response.data.result[0])
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setSubscribersList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_newsletter_email)
      }
    })
  }
  const handleExportExcel = () => {
    HttpService.getApi(API.GetSubscribersExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Subscribers')
      }
    })
  }

  const DeleteSubscriber = (e, id) => {
    swal(Messages.SwalDeactivateProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteSubscriber, param).then((response) => {
          setLoading(false)
          if (response.data.result) {
            toast.success(Messages.SubscriberDeactivated)
          }
          GetSubscribersList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Subscriber} </h3>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  // title="Subscriber List"
                  columns={columns}
                  data={SubscribersList}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  paginationDefaultPage={currentPage}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Subscribers
